import { useState } from "react";
import Icon from "../Icon";
import { RootState } from "@/store";
import { useAppSelector } from "@/store/hooks";
import { Input } from "antd";
import { useTranslation } from "next-i18next";

interface IInfo {
  title: string;
  content: string;
}
const InputItem = ({
  info,
  onEditBlur,
  validator,
  canEdit,
}: {
  info: IInfo;
  onEditBlur: Function;
  validator;
  canEdit: boolean;
}) => {
  const { title, content } = info;
  const [verifyError, setVerifyError] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const appStore = useAppSelector((state: RootState) => state.app);
  const { isMobile } = appStore;
  const [value, setValue] = useState(content);
  const { t } = useTranslation();

  const onBlurHandler = (e: any) => {
    const newValue = e.target.value;
    let hasError = false;
    if (validator) {
      hasError = !validator(newValue);
      setVerifyError(hasError);
    }
    onEditBlur(newValue, hasError);
    setValue(newValue);
    setIsEdit(false);
  };

  return (
    <div
      className={`h-[74px] border p-[10px] 
        ${verifyError ? "border-primary" : "border-[#E6E8EB]"} 
        ${isMobile ? "" : "w-[280px]"}
        ${canEdit ? "" : "bg-[#F1F1F1]"}
      `}
    >
      <div className="flex">
        <span className="text-[#979797]">{title}</span>
        {verifyError && (
          <span className="ml-4 flex flex-1 items-center text-primary">
            <Icon name="error_small" size={10} className="mr-1 inline"></Icon>
            {t("csr.err_info")}
          </span>
        )}
      </div>
      <div className="mt-[10px] flex items-center">
        {isEdit ? (
          <Input
            className="flex-1 !border-0 !pl-0 caret-primary !shadow-none !outline-none focus:!border-0 focus:!shadow-none"
            autoFocus
            defaultValue={value}
            onBlur={onBlurHandler}
          />
        ) : (
          <>
            <p className="flex-1">{value}</p>
            {canEdit && <Icon name="edit" size={20} onClick={() => setIsEdit(true)} />}
          </>
        )}
      </div>
    </div>
  );
};
export default InputItem;
